import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setPatientMedicalDeviceOrderingList,
  setPatientMedicalDeviceOrderingTypeList
} from 'src/store/modules/patient'

import {
  GET_MEDICAL_DEVICE_TYPES,
  MEDICAL_DEVICE_ORDERING_CANCEL_ORDER_MESSAGE,
  MEDICAL_DEVICE_ORDERING_GET_LIST,
  MEDICAL_DEVICE_ORDERING_SAVE_ORDER_MESSAGE,
  PATIENT_MEDICAL_DEVICE_DISCHARGE_LIVECARE_MESSAGE,
  PATIENT_MEDICAL_DEVICE_GET_LIVECARE_DISCHARGE_HISTORY,
  PATIENT_MEDICAL_DEVICE_ORDERING_PATCH_ORDER,
  PATIENT_MEDICAL_DEVICE_ORDERING_POST_CANCEL,
  PATIENT_MEDICAL_DEVICE_ORDERING_POST_ORDER,
  PATIENT_MEDICAL_DEVICE_POST_DISCHARGE_LIVECARE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const fetchPatientMedicalDeviceOrderingList =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: MEDICAL_DEVICE_ORDERING_GET_LIST,
          params,
          query
        }
      })

      dispatch(setPatientMedicalDeviceOrderingList(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const savePatientMedicalDeviceOrder =
  (config = {}) =>
  async () => {
    const { params = {}, payload = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: PATIENT_MEDICAL_DEVICE_ORDERING_POST_ORDER,
          params
        },
        payload
      })

      showSuccessModal({
        content: MEDICAL_DEVICE_ORDERING_SAVE_ORDER_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updatePatientMedicalDeviceOrder =
  (config = {}) =>
  async () => {
    const { params = {}, payload = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: PATIENT_MEDICAL_DEVICE_ORDERING_PATCH_ORDER,
          params
        },
        payload
      })

      showSuccessModal({
        content: MEDICAL_DEVICE_ORDERING_SAVE_ORDER_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const cancelPatientMedicalDeviceOrder =
  (config = {}) =>
  async () => {
    const { params = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: PATIENT_MEDICAL_DEVICE_ORDERING_POST_CANCEL,
          params
        }
      })

      showSuccessModal({
        content: MEDICAL_DEVICE_ORDERING_CANCEL_ORDER_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const fetchPatientMedicalDeviceOrderingTypes =
  (config = {}) =>
  async (dispatch) => {
    const { query = {} } = config

    try {
      const { items } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_MEDICAL_DEVICE_TYPES,
          query
        }
      })

      dispatch(setPatientMedicalDeviceOrderingTypeList(items))
    } catch (err) {
      catchError(err)
    }
  }

export const getLivecareDischargeHistory =
  (config = {}) =>
  async () => {
    const { params = {} } = config

    try {
      const history = await httpClient.request({
        method: 'get',
        url: {
          pathname: PATIENT_MEDICAL_DEVICE_GET_LIVECARE_DISCHARGE_HISTORY,
          params
        }
      })

      return history
    } catch (err) {
      catchError(err)

      return []
    }
  }

export const dischargeLivecarePatientDevice =
  (config = {}) =>
  async () => {
    const { payload = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: PATIENT_MEDICAL_DEVICE_POST_DISCHARGE_LIVECARE
        },
        payload
      })

      showSuccessModal({
        content: PATIENT_MEDICAL_DEVICE_DISCHARGE_LIVECARE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
